<template>
  <div class="body">
    <img src="../assets/img/m_head_more.jpg" class="head-img" alt="" />
    <div class="content">
      <div class="list">
        <img src="../assets/img/m_list_top.png" style="width: 100%;" alt="" srcset="">
        <div class="more">
          <div v-for="item in list" :key="item.id">
            <div class="list-content">
              <div class="list-avatar">
                <img src="../assets/img/avatar.png" alt="" srcset="" />
                <span>{{ item.info.name.substr(0, 1) }}**</span>
              </div>
              <div class="list-intro">
                {{ item.info.intro }}
              </div>
            </div>
          </div>
        </div>
        <div class="list-more" v-if="isMore" @click="onMore">
          <span>查看更多建言</span>
          <div class="list-more-arrow">
            <img src="../assets/img/news_arrow.png" alt="">
          </div>
        </div>
        <img src="../assets/img/m_list_bottom.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import CONFIG from "@/utils/config";
import COVERAPP from "@/utils/COVERAPP";
import COVER from "@/utils/COVER";

import { mapState, mapActions } from "vuex";

const info = {
  name: "",
  sex: "",
  age: "",
  intro: "",
};

let isSubmit = false;
const rows = 10;

export default {
  name: "home",
  data() {
    return {
      swiperOptions: {
        direction: "vertical",
        slidesPerView: 2,
        loop: true,
        autoplay: {
          disableOnInteraction: false,
        },
      },
      page: 1,
      isMore: true,
      list: [],
      nav: null,
      framework: CONFIG.framework,
      info,
      required: "",
    };
  },
  computed: {
    ...mapState(["shareData", "aid", "userinfo", "isPlayAudio"]),
  },
  created() {
    this.getList();
  },
  mounted() {
    const _this = this;
    isSubmit = false;
    this.share();
    document.querySelector(".loading-wrap").style.display = "none";
    this.setPageLoadingAsync(false);
  },
  methods: {
    ...mapActions(["setPageLoadingAsync", "Toast"]),
    share() {
      COVER.share(this.shareData);
    },
    onNav(index) {
      this.nav = index;
      this.$set(this.info, "type", this.framework[index].name);
      this.$nextTick(() => {
        this.$refs.name.focus();
      });
    },
    async getList() {
      const oldList = this.list;
      const res = await this.$request("/vote", "get", {
        aid: this.aid,
        page: this.page,
        rows,
      });

      if (res.errno === 0) {
        const list = res.data.list || [];
        this.list = [...oldList, ...list];
        if (list.length !== rows) {
          this.isMore = false;
        }
      }
    },
    async onSubmit() {
      if (isSubmit) {
        return;
      }
      let info = this.info;
      info.type = this.framework[this.nav].name.replace('<br>', '');
      this.required = "";

      for (let x in info) {
        if (!info[x]) {
          this.required = x;
          this.Toast({
            text: "请填写完整信息~",
          });
          return;
        }
      }

      isSubmit = true;
      let sbt = setTimeout(() => {
        document.querySelector(".loading-wrap").style.display = "flex";
      }, 1500);
      const res = await this.$request("/apply", "post", {
        aid: this.aid,
        token: new Date().getTime().toString(36),
        info,
      });

      isSubmit = false;
      clearTimeout(sbt);
      document.querySelector(".loading-wrap").style.display = "none";

      if (res.errno === 0) {
        this.Toast({
          text: "提交成功",
        });
        this.nav = null;
        this.onReset();
        return;
      }
    },
    onReset() {
      this.required = "";
      this.info = {
        name: "",
        sex: "",
        age: "",
        intro: "",
      };
    },
    onMore() {
      this.page++;
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.body {
  background: #f6f6f7;
  min-height: 100vh;
  width: 100vw;
}
.head-img {
  width: 100%;
}
.content {
  width: 100%;
  border-top-left-radius: 3vw;
  border-top-right-radius: 3vw;
  margin-top: -4vw;
  background: #f6f6f7;
  padding: 3.8vw;
  box-sizing: border-box;
  position: absolute;
  .title {
    display: table;
    width: 100%;
    margin-bottom: 3.6vw;
  }
  .news {
    a {
      text-decoration: none;
    }
    .news-item {
      background: linear-gradient(to bottom, #f5dc85, #fff, #f5dc85);
      border: 1px solid #c9231c;
      display: flex;
      border-radius: 2vw;
      font-size: 3.0vw;
      color: #444b51;
      line-height: 1.6em;
      box-shadow: 0 0 2vw rgba(#4c4633, .2);
      margin-bottom: 3.6vw;
      text-decoration: none;
      p {
        margin: 0;
        width: 100%;
        padding: 2.0vw;
        box-sizing: border-box;
        text-decoration: none;
      }
      .news-right {
        width: 7.4vw;
        background: #c9231c;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        border-top-right-radius: 2vw;
        border-bottom-right-radius: 2vw;
        img {
          width: 3.9vw;
          height: 3.6vw;
        }
      }
    }
  }
  .list {
    width: 100%;
    background-size: 100% 100%;
    margin-top: 2vw;
    box-sizing: border-box;
    font-size: 3.2vw;
    color: #444b51;
    .list-body {
      height: 35vw;
      margin-top: 4vw;
      padding: 0 3.8vw;
    }
    .list-content {
      display: flex;
      justify-content: space-between;
      .list-avatar {
        width: 9.5vw;
        display: flex;
        flex-direction: column;
        align-items: center;
        flex-shrink: 0;
        margin-right: 4vw;
        img {
          width: 9.5vw;
          height: 9.5vw;
          margin-bottom: 1vw;
        }
      }
      .list-intro {
        display: block;
        width: 73vw;
        border: 1px solid #cabd90;
        border-radius: 2vw;
        padding: 2.2vw 3.8vw 4vw 3.8vw;
        box-sizing: border-box;
        line-height: 1.9em;
        width: 100%;
        font-weight: 500;
        &::before {
          content: " ";
          width: 0;
          height: 0;
          border-top: 2vw solid transparent;
          border-right: 2vw solid #cabd90;
          border-bottom: 2vw solid transparent;
          border-left: 0;
          position: absolute;
          margin: 2vw 0 0 -5.9vw;
        }
      }
    }
    .list-more {
      border: 1px solid #c9231c;
      width: 44.6vw;
      display: flex;
      border-radius: 1.5vw;
      margin: 4vw auto 0 auto;
      text-decoration: none;
      font-size: 3.8vw;
      box-shadow: 0 0 2vw rgba(#4c4633, .2);
      span {
        width: 100%;
        display: table;
        text-align: center;
        padding: 2vw 0;
        background: #fbf0cc;
        color: #444b51;
        border-top-left-radius: 1.5vw;
        border-bottom-left-radius: 1.5vw;
        line-height: 1.3em;
      }
      .list-more-arrow {
        width: 8vw;
        background: #c9231c;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        border-top-right-radius: 1.5vw;
        border-bottom-right-radius: 1.5vw;
        img {
          width: 3.8vw;
        }
      }
    }
    .more {
      padding: 0 3.8vw;
      margin-top: 3vw;
      .list-content {
        margin-bottom: 2.0vw;
      }
    }
  }
  .nav {
    width: 100%;
    height: 103vw;
    background: url("../assets/img/m_type.png") top no-repeat;
    background-size: 100% 100%;
    margin-top: 2vw;
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 13vw 0 8vw 0;
    box-sizing: border-box;
    .nav-item {
      width: 30vw;
      height: 18.3vw;
      background: url("../assets/img/m_nav.png") center no-repeat;
      background-size: 100% 100%;
      font-size: 3.2vw;
      color: #c9231c;
      font-weight: bold;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-bottom: 2vw;
      box-sizing: border-box;
      text-align: center;
      &.nav-hover {
        transform: scale(1.1);
      }
      &.nav-nohover {
        opacity: 0.5;
      }
    }
  }
  .input {
    margin-top: 4vw;
    .input-title {
      width: 100%;
    }
    .input-content {
      width: 100%;
      background: #fff;
      font-size: 3.8vw;
      color: #444b51;
      padding: 5vw 3.6vw;
      box-sizing: border-box;
      border-bottom-left-radius: 2vw;
      border-bottom-right-radius: 2vw;
      .input-item {
        margin-bottom: 4vw;
        .input-name {
          margin-bottom: 2vw;
          span {
            color: #c9231c;
          }
        }
        .input-intro {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          input,
          select,
          textarea {
            width: 52vw;
            border: 1px solid #d7c9a0;
            border-radius: 1vw;
            padding: 1.5vw 2vw;
            background: transparent;
            box-sizing: border-box;
            margin-right: 3vw;
            outline: 0;
            line-height: 1.5em;
            font-size: 3.4vw;
          }
          span {
            color: #c9231c;
            font-size: 3.2vw;
          }
        }
      }
      .input-btn {
        display: flex;
        padding: 0 3vw;
        justify-content: space-between;
        button {
          width: 37vw;
          line-height: 11vw;
          color: white;
          padding: 0;
          border-radius: 1.5vw;
          border: 0;
          font-weight: bold;
          &:first-child {
            background: #c9231c;
            border: 1px solid #c9231c;
          }
          &:last-child {
            background: transparent;
            color: #c9231c;
            border: 1px solid #c9231c;
          }
        }
      }
    }
  }
}
</style>